import {BehaviorSubject} from 'rxjs';

export interface PlusMenu {
  poiBtnDisabled: boolean;
  saveBtnDisabled: boolean;
  undoBtnDisabled: boolean;
  redoBtnDisabled: boolean;
}

export interface ManagerFacade {
  snapping: boolean;
  undo: () => void;
  redo: () => void;
  reverse: () => void;
}

const initialState: PlusMenu = Object.freeze({
  poiBtnDisabled: false,
  saveBtnDisabled: false,
  undoBtnDisabled: true,
  redoBtnDisabled: true,
});

export const plusMenu$ = new BehaviorSubject(initialState);

// These functions expose a subset of the manager
let managerFacade: ManagerFacade;
export function setPlusMenuManager(manager: ManagerFacade) {
  managerFacade = manager;
}

export function getManagerFacade() {
  return managerFacade;
}
